import DomEventHelper from '@/helpers/DomEventHelper';
import ErrorHandlerHelper from '@/helpers/ErrorHandlerHelper';
import config from '../../config';
import CookieHelper from '@/helpers/CookieHelper';

export default class AnnouncementBarService {
  private errorTimeout: NodeJS.Timeout | undefined;
  private evtSource: EventSource | undefined;
  public static isConnected = false;

  public reconnect(): void {
    setTimeout(() => {
      this.connect();
    }, 3000);
  }

  public async connect(): Promise<void> {
    try {
      const deliveryAddressIso = CookieHelper.getDeliveryAddressIso();
      let countryIso = ``;
      if(deliveryAddressIso) {
        countryIso = `/${deliveryAddressIso}`;
      }
      this.evtSource = new EventSource(`${config.announcementbar.url}${config.announcementbar.paths.eventstream}${countryIso}`);
      this.addEventListeners();
    } catch (err) {
      ErrorHandlerHelper.handleError(err, { logToConsole: true });
    }
  }

  public deconnect(): void {
    this.removeEventListeners();
    this.evtSource?.removeEventListener(`error`, this.closeByError.bind(this));
    this.evtSource?.close();
    this.reconnect();
  }

  private closeByError(): void {
    this.errorTimeout = setTimeout(() => {
      AnnouncementBarService.isConnected = false;
      this.deconnect();
    }, 5000);
  }

  private addEventListeners(): void {
    if(!this.evtSource) {
      return;
    }
    this.evtSource.addEventListener(`error`, this.closeByError.bind(this));
    this.evtSource.addEventListener(`connection-established`, this.connected);
    this.evtSource.addEventListener(`update-bar`, AnnouncementBarService.updateBar);
    this.evtSource.addEventListener(`remove-bar`, AnnouncementBarService.removeBar);
  }

  private removeEventListeners(): void {
    if(!this.evtSource) {
      return;
    }
    this.evtSource.removeEventListener(`connection-established`, this.connected);
    this.evtSource.removeEventListener(`update-bar`, AnnouncementBarService.updateBar);
    this.evtSource.removeEventListener(`remove-bar`, AnnouncementBarService.removeBar);
  }

  private connected(): void {
    AnnouncementBarService.isConnected = true;
    if(this.errorTimeout) {
      clearTimeout(this.errorTimeout);
    }
  }

  private static updateBar(evt: Event): void {
    const event = (evt as MessageEvent);
    DomEventHelper.fireEvent({ detail: event.data, name: `update-announcementbar` });
  }

  private static removeBar(): void {
    DomEventHelper.fireEvent({ name: `remove-announcementbar` });
  }
}
